import {
    Logger,
    LoggerDateTimeDecorator,
    buildEmptyObjectContainer,
    Getter,
    ConfigStorage,
    SharedStorageInitValue,
    SharedStoragePersistDecorator,
    SharedStorageMock,
    SharedStorageRedux,
    SharedStorageAgentRedux,
    SharedStorageSubscribeStrategyRedux,
    SharedStorageReduxReducersGenerator,
    SharedStorageQiankun,
    SharedStorageAgentQiankun,
    SharedStorageAgentSubscribeWrapperQiankun,
    SharedStorageGlobalSubscribeStrategyQiankun,
    ValueComparer
 } from "./index.js";

const buildOC = () => {
    const libOC = buildEmptyObjectContainer();
    
    const _buildLogger = (container, parent) => {        
        return new LoggerDateTimeDecorator(
            new Logger()
        );
    }
    libOC.set("Logger", _buildLogger);
    
    const _buildGetter = (container, parent) => {        
        return new Getter();
    }
    libOC.set("Getter", _buildGetter);

    const _buildConfigStorage = (container, parent) => {
        return new ConfigStorage();
    }
    libOC.set("ConfigStorage", _buildConfigStorage);

    const _buildValueComparer = (container, parent) => {
        return new ValueComparer();
    }
    libOC.set("ValueComparer", _buildValueComparer);

    const _build_SharedStorageInitValue = (container, parent) => {
        return new SharedStorageInitValue();
    }
    libOC.set("SharedStorageInitValue", _build_SharedStorageInitValue);

    // returns the shared storage class to use from a collection using the __ICLIB_SHARED_STORAGE_TYPE__ global variable
    const _chooseSharedStorageClass = (className, classColl) => {
        const sharedStorageType = window.__ICLIB_SHARED_STORAGE_TYPE__;
        const resultClass = classColl[sharedStorageType];
        if (!resultClass) {
            throw new Error(`Unable to find build ${className} for type ${sharedStorageType}. Please set a valid __ICLIB_SHARED_STORAGE_TYPE__ global variable`)
        }
        return resultClass;
    }

    const _build_SharedStorageAgent = (container, parent) => {
        const sharedStorageAgentBuilderColl = {
            "qiankun": () => (
                new SharedStorageAgentSubscribeWrapperQiankun(
                    new SharedStorageAgentQiankun(
                        container.get("ConfigStorage").get("qiankun_method"),            
                        container.get("ConfigStorage").get("qiankun_application"),  
                        container.get("SharedStorageInitValue").getInitValue()
                    )
                )
            ),
            "redux": () => (
                new SharedStorageAgentRedux(
                    container.get("ConfigStorage").get("redux_store"),
                    container.get("SharedStorageInitValue").getInitValue()
                )
            )
        }
        const sharedStorageAgent = _chooseSharedStorageClass("SharedStorageAgent", sharedStorageAgentBuilderColl)();
        return sharedStorageAgent;
    }
    libOC.set("SharedStorageAgent", _build_SharedStorageAgent);

    const _build_SharedStorageSubscribeStrategy = (container, parent) => {
        const sharedStorageSubscribeStrategy = new SharedStorageSubscribeStrategyRedux(
            container.get("SharedStorageAgent"),
            container.get("ConfigStorage").get("redux_store")
        );
        return sharedStorageSubscribeStrategy;
    }
    libOC.set("SharedStorageSubscribeStrategy", _build_SharedStorageSubscribeStrategy);

    const _build_SharedStorage = (container, parent) => {
        const sharedStorageBuilderColl = {
            "qiankun": () => (
                new SharedStoragePersistDecorator(
                    new SharedStorageQiankun(
                        container.get("SharedStorageAgent")
                    ),
                    container.get("SharedStorageInitValue").getInitValue()            
                )
            ),
            "redux": () => (
                new SharedStoragePersistDecorator(
                    new SharedStorageRedux(
                        container.get("SharedStorageAgent"),
                        container.get("SharedStorageSubscribeStrategy")
                    ),
                    container.get("SharedStorageInitValue").getInitValue()            
                )
            ),
            // "only_persist" 
            //  allows for values to be set in persisted storage, but doesn't really allow for retrieval
            //  so the cisobot webapp can set values for the comp webapp
            "only_persist": () => (
                new SharedStoragePersistDecorator(
                    new SharedStorageMock(),
                    container.get("SharedStorageInitValue").getInitValue() 
                )
            )
        }
        const sharedStorage = _chooseSharedStorageClass("SharedStorage", sharedStorageBuilderColl)();
        return sharedStorage;
    }
    libOC.set("SharedStorage", _build_SharedStorage);

    const _build_SharedStorageReduxReducersGenerator = (container, parent) => {
        return new SharedStorageReduxReducersGenerator(
            container.get("SharedStorageInitValue").getInitValue()
        );
    }
    libOC.set("SharedStorageReduxReducersGenerator", _build_SharedStorageReduxReducersGenerator);

    const _build_SharedStorageGlobalSubscribeStrategyQiankun = (container, parent) => {
        return new SharedStorageGlobalSubscribeStrategyQiankun(
            container.get("SharedStorage"),
            container.get("ConfigStorage").get("qiankun_method"),
            container.get("ValueComparer")        
        );
    }
    libOC.set("SharedStorageGlobalSubscribeStrategyQiankun", _build_SharedStorageGlobalSubscribeStrategyQiankun);

    return libOC;
}

export default buildOC;
